import request from "@/utils/http"
import store from "@/store"
import { getCachedObj } from "@/utils/cache"
import { cacheRequest } from "@/utils/decorator"
import * as TemplateApi from "@/api/public/template"
import { isObject } from "lodash"

export function login(username, password) {
  return request.post("/login", { username, password }).commonDeal()
}

export function sendUnregisterAccountVerifyCode() {
  return request.post("/users/sendUnregisterAccountVerifyCode").commonDeal()
}

export function unregisterUser(verifyCode) {
  return request.post("/users/unregisterUser", {}, { params: { verifyCode } }).commonDeal()
}

// 工作表数据收藏
export function saveFavorite({ appId, dataId, description, sheetId, id }) {
  return request
    .post("/users/saveFavorite", { appId, dataId, description, sheetId, id })
    .commonDeal()
}

export function deleteFavorite(favoriteId) {
  return request.post("/users/deleteFavorite", {}, { params: { favoriteId } }).commonDeal()
}

export function getFavorites({ appId, description, page, size, sheetId }) {
  return request
    .post("/users/getFavoriteList", { appId, description, page, size, sheetId })
    .commonDeal()
}

export function getLoginScanCode() {
  return request.get("/public/login/code").commonDeal()
}

export function getScanResult(code, scanned = false) {
  return request.post("/public/login/QR", null, { params: { code, scanned } }).commonDeal()
}

export function getCurUser() {
  return request.get("/users/whoami")
}

export function getCompanyDashboardVo() {
  return request.get("/users/getCompanyDashboardVo").commonDeal()
}

export function getRecordList(companyId) {
  return request.post("/users/getRecordList", {}, { params: { companyId } }).commonDeal()
}

export function setCompanyState(params) {
  return request.post("/users/setCompanyState", params)
}

export function verifyJoinRecord(pass, recordId, scope) {
  return request.post("/users/verifyJoinRecord", scope, { params: { pass, recordId } }).commonDeal()
}

export function transferCompany(companyId, userId) {
  return request.post("/users/transferCompany", {}, { params: { companyId, userId } })
}

export function deleteCompany(companyId) {
  return request.post("/users/deleteCompany", {}, { params: { companyId } }).commonDeal()
}

export function getAllAppTemplates() {
  if (store.getters.isTemplateMode) {
    return TemplateApi.getAllPublicAppTemplateList()
  }
  return request.get("/users/getAllAppTemplates").commonDeal()
}

export function getAppTemplate(id, cache = false) {
  return userApi.getAppTemplate(id, cache)
}

export function getCompanyLogList({
  businessId,
  endTime,
  page = 1,
  size = 100,
  startTime,
  type,
  typeGroup,
  userId
}) {
  return request
    .post(`/users/getCompanyLogList`, {
      businessId,
      endTime,
      page: page - 1,
      size,
      startTime,
      type,
      typeGroup,
      userId
    })
    .commonDeal()
}

export function exportCompanyLog({
  businessId,
  endTime,
  page = 1,
  size = 100,
  startTime,
  type,
  typeGroup,
  userId
}) {
  return request
    .post(`/users/exportCompanyLog`, {
      businessId,
      endTime,
      page: page - 1,
      size,
      startTime,
      type,
      typeGroup,
      userId
    })
    .commonDeal()
}

export function saveAppGroupList(appGroups) {
  return request.post("/users/saveAppGroupList", appGroups)
}

export function getAppGroupList() {
  if (store.getters.isTemplateMode) return Promise.resolve([])
  return request.get("/users/getAppGroupList").commonDeal()
}

export function saveProjectGroupList(projectGroups) {
  return request.post("/users/saveProjectGroupList", projectGroups)
}

export function getProjectGroupList() {
  if (store.getters.isTemplateMode) return Promise.resolve([])
  return request.get("/users/getProjectGroupList").commonDeal()
}

export function getSimpleUser({ userId = store.getters.userId, cache = true } = {}) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve({ name: "测试用户" })
  }
  let reqFunc = () => request.get("/users/getSimpleUser", { params: { userId } }).commonDeal()
  if (!cache) {
    return reqFunc()
  }
  let key = `getSimpleUser${userId}`
  return getCachedObj({ key, reqFunc })
}

export function getCurPri() {
  return request.get("/users/pri").commonDeal()
}

export function updatePassword(oldPassword, newPassword) {
  return request.get(`/users/updatePassword/${oldPassword}/${newPassword}`).commonDeal()
}

export function updateUser({ id, name, birthday, avatar, email }) {
  return request.post("/users/update", { id, name, birthday, avatar, email })
}

export function switchUserState(userId) {
  return request.post("/users/switchUserState", null, { params: { userId } }).commonDeal()
}

export function leaveCompany(companyId) {
  return request.post("/users/leaveCompany", null, { params: { companyId } }).commonDeal()
}

export function getSimpleUsers(userIds) {
  return request.post("/users/getSimpleUsers", userIds).commonDeal()
}

export function getFavoriteList(type) {
  if (store.getters.isTemplateMode) return Promise.resolve([])
  return request.get(`/users/getFavoriteList`, { params: { type } }).commonDeal()
}

// //////////////////////////////////////////////////////// 无需登录即可调用的API以public开头

export function sendRegisterVerifyCode(telephone) {
  return request
    .post("/public/sendRegisterVerifyCode", null, { params: { telephone } })
    .commonDeal()
}

export function sendResetPasswordVerifyCode(telephone) {
  return request
    .post("/public/sendResetPasswordVerifyCode", null, { params: { telephone } })
    .commonDeal()
}

export function registerUser(telephone, password, verifyCode) {
  return request
    .post("/public/registerUser", null, {
      params: { telephone, password, verifyCode }
    })
    .commonDeal()
}

export function forceChangePassword(telephone, password, verifyCode) {
  return request
    .post("/public/forceChangePassword", null, {
      params: { telephone, password, verifyCode }
    })
    .commonDeal()
}

export function codeVerify(telephone, verifyCode) {
  return request
    .post("/public/codeVerify", null, { params: { telephone, verifyCode } })
    .commonDeal()
}

export function getVerifyProcess(processInstanceId) {
  return request.get(`/users/getVerifyProcess`, { params: { processInstanceId } }).commonDeal()
}

export function getVerifyRecordForDetail(verifyRecordId) {
  return request.get(`/users/getVerifyRecordForDetail`, { params: { verifyRecordId } }).commonDeal()
}

export function getVerifyButtonList(verifyRecordId) {
  return request.get(`/users/getVerifyButtonList`, { params: { verifyRecordId } }).commonDeal()
}

export function exportCurCompanyUser() {
  return request.get("/users/exportUser").commonDeal()
}

export function setFrontSetting(setting, itemId, type) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve()
  }
  if (!itemId || !type) {
    console.error("参数不全")
    return Promise.resolve()
  }
  return request
    .request({
      url: "/users/setFrontSetting",
      method: "post",
      params: { itemId, type },
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(setting)
    })
    .commonDeal()
}

export function getFrontSetting(itemId, cache = false) {
  return userApi.getFrontSetting(itemId, cache)
}

/**
 * 获取应用内所有用户
 * @param appId
 * @param cache
 * @returns {*}
 */
export function getAppUsers({ appId, cache = true } = {}) {
  return userApi.getAppUsers(appId, cache)
}

class UserApi {
  @cacheRequest()
  getFrontSetting(itemId, cache) {
    if (store.getters.isTemplateMode) return Promise.resolve()
    if (!itemId) {
      console.error("参数不全")
      return Promise.resolve()
    }
    return request.post("/users/getFrontSetting", null, { params: { itemId } }).commonDeal()
  }

  @cacheRequest()
  getAppTemplate(id, cache) {
    if (store.getters.isTemplateMode) return TemplateApi.getAppTemplateDetail(id)
    return request.get("/users/getAppTemplate", { params: { id } }).commonDeal()
  }

  @cacheRequest()
  getAppUsers(appId, cache) {
    return store.getters.isTemplateMode || !appId
      ? Promise.resolve([])
      : request.get("/users/getAppUsers", { params: { appId } }).commonDeal()
  }
}
const userApi = new UserApi()
